import { useCallback, useState } from 'react';
import { uploadDrafts, type DraftMedia } from '@/utils/media';

/**
 * 저장 버튼을 누를 때 아직 올리지 않은 첨부를 S3 에 올린다.
 * progress 는 업로드 중일 때만 0~100 이고, 평소에는 null 이다.
 *
 * @example
 * const uploader = useMediaUpload('boards');
 * mutationFn: async () => {
 *   const uploaded = await uploader.upload(media);
 *   setMedia(uploaded); // 저장이 실패해 다시 눌러도 같은 파일을 두 번 올리지 않는다
 *   return boardApi.create({ ..., media: toMediaInputs(uploaded) });
 * }
 */
export function useMediaUpload(prefix: 'products' | 'reviews' | 'boards') {
  const [progress, setProgress] = useState<number | null>(null);

  const upload = useCallback(
    async (drafts: DraftMedia[]) => {
      if (!drafts.some((draft) => draft.file)) return drafts;
      setProgress(0);
      try {
        return await uploadDrafts(drafts, prefix, setProgress);
      } finally {
        setProgress(null);
      }
    },
    [prefix],
  );

  return { upload, progress };
}
